<template>
    <div class="type-div">
        <img class="img-box" :src="defaultImage" alt="">
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import defaultImage from './ALLONX.svg'

const props = defineProps({
    paramsBg: {
        type: String,
        required: true
    }
})
const backgroundUrl = ref('');
</script>

<style lang="scss" scoped>
.type-div{
    .img-box{
        width: 100%;
        height: 100%;
        background-size: 100% 100% !important;
        background-repeat: no-repeat;
    }
}
</style>